import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "service";
import { IErrorResponse } from "types";
import {
    deletedRestorePositionsHours,
    deletePositionsHours,
    setPositionsHours,
    setPositionsHoursRestore,
} from "./positionsHoursSlice";
import { IPositionsHoursCreate, IPositionsHoursPayload } from "../types";

const GetPositionsHours = createAsyncThunk("get/positions/hours", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("/rates");

        dispatch(setPositionsHours(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const CreatePositionsHours = createAsyncThunk(
    "create/positions/hours",
    async (data: IPositionsHoursCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/rates", data);
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeletePositionsHours = createAsyncThunk(
    "delete/positions/hours",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/rates/${id}`);

            dispatch(deletePositionsHours(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const EditPositionsHours = createAsyncThunk(
    "edit/positions/hours",
    async (data: IPositionsHoursPayload, { rejectWithValue }) => {
        try {
            const response = await request.put(`/rates/${data.id}`, data);
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeletedPositionsHours = createAsyncThunk(
    "get/delete/positions/hours",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get(`/rates/deleted-items`);

            dispatch(setPositionsHoursRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const RestoreDeletePositionsHours = createAsyncThunk(
    "restore/delete/positions/hours",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/rates/restore/${id}`);

            dispatch(deletedRestorePositionsHours(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetPositionsHours,
    CreatePositionsHours,
    DeletePositionsHours,
    EditPositionsHours,
    GetDeletedPositionsHours,
    RestoreDeletePositionsHours,
};
